import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

import { Paper, Typography } from '@mui/material';

import { stylesCookiesListPaper } from './CookiesList.styles';

export function CookiesList() {
  const { t } = useTranslation('customsPass_cookiesListPage');

  return (
    <>
      <Typography variant='h1' mb={3}>
        {t('cookiesList.title')}
      </Typography>
      <Paper sx={stylesCookiesListPaper}>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('cookiesList.content')}</ReactMarkdown>
        </Typography>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          {t('cookiesList.subjects')}
        </Typography>
        <Typography variant='bodyMD' component='p' fontWeight='fontWeightSemiBold' mb={2}>
          <ReactMarkdown>{t('cookiesList.subjects.content')}</ReactMarkdown>
        </Typography>
        <Typography
          mb={2}
          component='div'
          variant='bodyMD'
          fontWeight='fontWeightSemiBold'
          id='control-and-delete-sherpass-cookies'
        >
          {t('cookiesList.controleAndDeleteSherpassCookies.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('cookiesList.controleAndDeleteSherpassCookies.content')}</ReactMarkdown>
        </Typography>

        <Typography
          mb={2}
          component='div'
          variant='bodyMD'
          fontWeight='fontWeightSemiBold'
          id='installed-cookies-by-sherpass'
        >
          {t('cookiesList.installedSherpassCookies.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('cookiesList.installedSherpassCookies.content')}</ReactMarkdown>
        </Typography>

        <Typography
          mb={2}
          component='div'
          variant='bodyMD'
          id='manage-sherpass-cookies'
          fontWeight='fontWeightSemiBold'
        >
          {t('cookiesList.howToManageSherpassCookies.title')}
        </Typography>
        <Typography variant='bodyMD' component='p' mb={3}>
          <ReactMarkdown>{t('cookiesList.howToManageSherpassCookies.content')}</ReactMarkdown>
        </Typography>
      </Paper>
    </>
  );
}
